"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitIndustryPassAttestationResponseStatusEnum = exports.SubmitIndustryPassAttestationResponseToJSON = exports.SubmitIndustryPassAttestationResponseFromJSONTyped = exports.SubmitIndustryPassAttestationResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function SubmitIndustryPassAttestationResponseFromJSON(json) {
    return SubmitIndustryPassAttestationResponseFromJSONTyped(json, false);
}
exports.SubmitIndustryPassAttestationResponseFromJSON = SubmitIndustryPassAttestationResponseFromJSON;
function SubmitIndustryPassAttestationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'attestationId': !(0, runtime_1.exists)(json, 'attestationId') ? undefined : json['attestationId'],
        'passAmount': !(0, runtime_1.exists)(json, 'passAmount') ? undefined : json['passAmount'],
        'estimatedUsdValue': !(0, runtime_1.exists)(json, 'estimatedUsdValue') ? undefined : json['estimatedUsdValue'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.SubmitIndustryPassAttestationResponseFromJSONTyped = SubmitIndustryPassAttestationResponseFromJSONTyped;
function SubmitIndustryPassAttestationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'attestationId': value.attestationId,
        'passAmount': value.passAmount,
        'estimatedUsdValue': value.estimatedUsdValue,
        'status': value.status,
        'message': value.message,
    };
}
exports.SubmitIndustryPassAttestationResponseToJSON = SubmitIndustryPassAttestationResponseToJSON;
/**
* @export
* @enum {string}
*/
var SubmitIndustryPassAttestationResponseStatusEnum;
(function (SubmitIndustryPassAttestationResponseStatusEnum) {
    SubmitIndustryPassAttestationResponseStatusEnum["PENDINGREVIEW"] = "PENDING_REVIEW";
})(SubmitIndustryPassAttestationResponseStatusEnum = exports.SubmitIndustryPassAttestationResponseStatusEnum || (exports.SubmitIndustryPassAttestationResponseStatusEnum = {}));
